var _polygon, _line, _line2, _line3, _circle, _circle2, _line4, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "27,8 67,8 87,44 67,82 27,82 7,44",
    fill: "#00BFA5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 70,
    x2: 23,
    y2: 20,
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 20,
    x2: 71,
    y2: 70,
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 70,
    x2: 71,
    y2: 20,
    stroke: "#1A5C54",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 20,
    r: 6,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 20,
    r: 6,
    fill: "#1A5C54",
    opacity: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 10,
    x2: 102,
    y2: 80,
    stroke: "#00BFA5",
    strokeWidth: 2.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 50,
    fontFamily: "Orbitron, sans-serif",
    fontWeight: 700,
    fontSize: 34,
    fill: "#00BFA5",
    letterSpacing: 1
  }, "NEXUS")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 74,
    fontFamily: "Orbitron, sans-serif",
    fontWeight: 400,
    fontSize: 21,
    fill: "#007A6E",
    letterSpacing: 8
  }, "CARGO")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8d1ed799224af38b0d31fdd10a4c90ef.svg";
export { ForwardRef as ReactComponent };